import $$ from 'jquery'
import ExoForm from '@/common/FF/ExoForm'

import bsCustomFileInput from 'bs-custom-file-input'
import fileFiled from '@/common/FF/Fields/fileFiled'
import exoUploader from '@/common/FF/Fields/fileFiled/uploader'
import phoneField from '@/common/FF/Fields/phone'
import passportField from '@/common/FF/Fields/passport'
import passwordField from '@/common/FF/Fields/password'

const FF = {
    forms: [],
    init() {
        //todo pass theme from server
        bsCustomFileInput.init()
        fileFiled.init()
        exoUploader.init()
        phoneField.init()
        passportField.init()
        passwordField.init()

        $$('.ff-exo-form').each((index, el) => {
            const $el = $$(el)
            const form = new ExoForm($el)
            form.initCaptcha()
            this.forms.push(form)
        })

        // A textarea with a few rich-text controls (a blog's comment) brings
        // an editor of its own: only a page that has one loads it - or one
        // that shows its owner the comments that wait, whose controls it works.
        if (document.querySelector('textarea[data-exo-richtext], [data-comment-admin]')) {
            import(/* webpackChunkName: "exolog-richtext" */ '@/common/FF/Fields/richtext')
                .then(m => m.default.init())
                .catch(e => console.error(e))
        }
    },
    findById(form_id) {
        return this.forms.filter(form => +form_id === form.getFormId())
    },
    findByName(form_name) {
        return this.forms.filter(form => form_name === form.getFormName())

    },
    first(identifier) {
        return this.forms.find(exoForm => identifier === exoForm.getFormName() || identifier == exoForm.getFormId())
    },
    initReCaptcha() {
        this.forms.forEach(form => form.initCaptcha())
    }
}
//expose FF to client site js
window.FF = FF;
window._initReCaptcha = FF.initReCaptcha.bind(FF)

export default FF;
